import { Select } from '@naf/input';
import styled from '@emotion/styled';
import { GridCol } from '@naf/grid';
import { breakpoints, spacing } from '@naf/theme';

export const SelectGridCol = styled(GridCol)`
  margin-bottom: ${spacing.space8};
  margin-top: ${spacing.space32};
`;

export const SelectWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing.space16};

  @media (max-width: ${breakpoints.m}) {
    flex-direction: column;
    gap: ${spacing.space12};
  }
`;

export const StyledSelect = styled(Select)`
  width: 100%;
  height: ${spacing.space80};

  & > div {
    top: ${spacing.space80};
  }

  @media (max-width: ${breakpoints.m}) {
    height: 60px;

    & > div {
      top: 60px;
    }
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  height: ${spacing.space80};
`;

export const LocationErrorContainer = styled.div`
  margin-top: ${spacing.space24};
`;
